import dayjs from "dayjs";
import * as yup from "yup";

const validation = (errors, { lockStartDate = false } = {}) =>
  yup.object().shape({
    name: yup.string().trim().required(errors.REQUIRED),
    platform: yup.string().trim(),
    process: yup.object().shape({
      id: yup.string().trim().required(errors.REQUIRED),
    }),
    startDate: yup
      .mixed()
      .nullable()
      .test("not-in-past", errors.MIN_TODAY, (startDate) => {
        if (lockStartDate || !startDate) return true;
        return !dayjs(startDate).isBefore(dayjs(), "day");
      }),
    endDate: yup
      .mixed()
      .nullable()
      .test(
        "after-start",
        errors.SOURCE_END_BEFORE_START,
        function isAfterStart(endDate) {
          const { startDate } = this.parent;
          if (!startDate || !endDate) return true;
          return !dayjs(endDate).isBefore(dayjs(startDate), "day");
        },
      ),
    fixed: yup.boolean(),
  });

export default validation;
